import swiperWidget from './swiperWidget';
export default function () {
  const widgetName = 'vimeoWidget';
  const widgetOpts = vimeoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (slide) {
      let videoActive = slide.items.length;
      function addClass() {
        $(`#${widgetName} .card-widget-item`).each(function (x) {
          let vimeoURLAttr = $(slide.items[x].Description)
            .find('iframe')
            .attr('src');
          videoActive = slide.items[x].Description.length;
          vimeoURLAttr = `${vimeoURLAttr}&background=1`;
          $(this)
            .find('.card-widget-description iframe')
            .attr('src', vimeoURLAttr);
          $(this).find('.card-widget-title').remove();
          $(this).find('.buttonwrap').remove();
        });
        if (videoActive < 1) {
          $(`#${widgetName}`).remove();
          swiperWidget();
        } else {
          $('body').addClass('vimeo-active');
          $('#swiperWidget').remove();
        }
      }

      addClass();
    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'More',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
